
import { mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'FicheSalarie',
  computed: {
    ...mapGetters({ user: 'user/user' })
  }
});
